import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-simulator-card',
  templateUrl: './simulator-card.component.html',
  styleUrls: ['./simulator-card.component.scss'],
})
export class SimulatorCardComponent implements OnInit {
  @Input() header: string = '';
  @Input() showHeader: boolean = true;
  @Input() showFooter: boolean = false;
  @Input() overflowHidden: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}